<template>
    <div>
        <div class="col-12 form-group">
            <label for="articleSearch">
                Search for articles
            </label>
            <div class="d-flex align-items-center">
                <div style="flex: 1">
                    <v-select
                        v-model="selectedArticle"
                        label="name"
                        :clearable="false"
                        :options="articlesOptions"
                        @search="onArticleSearch"
                    >
                        <template slot="no-options">
                            Type to search for articles...
                        </template>
                    </v-select>
                </div>
                <button
                    class="col-1 ml-1 btn btn-success waves-effect waves-ligh"
                    type="button"
                    @click="addArticle"
                >
                    <i class="fas fa-plus-circle" />
                </button>
            </div>
        </div>
        <awesome-table
            v-if="articles.length"
            :labels="labels"
            :items="articles"
            :options="{
                addButton: false,
                pagination: false,
                clickableRows: false,
                searchInput: false,
                isCard: false,
                link: false,
                filters: false
            }"
        >
            <template #[`items.actions`]="{ index }">
                <a
                    href="#"
                    class="action-icon"
                    @click.prevent="deleteArticle(index)"
                >
                    <i class="far fa-trash-alt" />
                </a>
            </template>
        </awesome-table>
        <div v-else class="text-center">
            No articles added yet!
        </div>
    </div>
</template>

<script>
import { mapActions } from 'vuex';

export default {
    props: {
        value: {
            type: Array,
            required: true
        }
    },

    data() {
        return {
            labels: [
                {
                    value: 'name',
                    sortable: false
                },
                {
                    value: 'actions',
                    sortable: false
                }
            ],
            articles: [...this.value],
            articlesOptions: [],
            selectedArticle: null
        };
    },

    methods: {
        ...mapActions({
            getAvailableArticles: 'articles/index'
        }),

        async onArticleSearch(search, loading) {
            if (search.length) {
                if (this.timer) {
                    clearTimeout(this.timer);
                    this.timer = null;
                }

                loading(true);

                this.timer = setTimeout(async () => {
                    const { rows } = await this.getAvailableArticles({
                        search,
                        isPublic: true
                    });

                    this.articlesOptions = rows;

                    loading(false);
                }, 500);
            }
        },

        addArticle() {
            if (!this.selectedArticle) {
                return;
            }

            const isAlreadyAdded = this.articles.find(
                article => this.selectedArticle.id === article.id
            );

            if (isAlreadyAdded) {
                this.$bvToast.toast('Article is already added!', {
                    title: 'Warning!',
                    variant: 'warning',
                    solid: true
                });

                return;
            }

            this.articles.push({ ...this.selectedArticle });

            this.$emit('input', this.articles);

            this.selectedArticle = null;
        },

        deleteArticle(index) {
            this.articles.splice(index, 1);

            this.$emit('input', this.articles);
        }
    }
};
</script>
